import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, ArticleSection, StyledButton } from "../components";
import { useScrollToTopAndNavigate } from "../hooks";
import { useTranslation } from "react-i18next";

import content from "../config/FAQs.json";

import bg_05 from "./../images/Content/haeussler-job-01.webp"
import bg_03 from "./../images/Content/Backhaus-Häussler-34.jpg"

const FAQs: React.FunctionComponent = () => {
  const { t } = useTranslation(["faqs", "common"]);
  const handleNavigation = useScrollToTopAndNavigate();

  const contentColStyle: React.CSSProperties = {
    flex: 7,
    padding: "1rem",
    textAlign: "right"
  };

  const headerStyle: React.CSSProperties = {
    fontWeight: 700,
    fontSize: "1.5rem",
    lineHeight: "12px",
    letterSpacing: ".25em",
    display: "block",
    padding: 0,
    marginBottom: "10px",
    textTransform: "uppercase",
    color: "#c39d63",
    fontFamily: "Avenir Next Codensed Ultralight",
  };

  const subHeaderStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Codensed Ultralight",
    fontStyle: "normal",
    fontWeight: 300,
    fontSize: "64px",
    lineHeight: "62px",
    letterSpacing: ".03em",
    textTransform: "capitalize",
    color: "#514633",
    display: "block",
    marginBottom: "65px",
  };

  const contentStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Codensed Regular",
    fontWeight: 300,
    fontSize: "28px",
    lineHeight: "45px",
    color: "#342714",
    letterSpacing: ".05em"
  };

  const accordionTitleStyle: React.CSSProperties = {
    fontSize: "2rem",
    fontWeight: 300,
    margin: "calc(2rem - .14286em) 0 1rem",
    fontFamily: "Avenir Next Codensed Ultralight",
  };

  const accordionHeaderStyle: React.CSSProperties = {
    background: "transparent",
    borderBottom: "1px solid #2d2d2d",
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
    minWidth: "100%",
    textAlign: "left"
  };

  const accordionContentStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Codensed Regular",
    fontWeight: 300,
    fontSize: "20px",
    lineHeight: "24px",
    textTransform: "capitalize",
    color: "#342714",
    marginTop: "1.5rem",
  };

  return (
    <Container>
      <ArticleSection
        layout="article_right_bg"
        title={t("sections.intro.title")}
        content={
          <div style={contentStyle}>{t("sections.intro.content")}</div>
        }
        imageUrl={bg_03}
        backgroundColor="#F4EBE5"
      />
      <section>
        <Row>
          <Col xxl={6} xl={6} lg={4} md={12} sm={12} xs={12}>
            <div style={contentColStyle}>
              <h4 style={headerStyle}>{t("page_header.headline")}</h4>
              <div style={subHeaderStyle}>{t("page_header.subheadline")}</div>
              <p style={contentStyle}>{t("page_header.content")}</p>
            </div>
          </Col>
          <Col xxl={6} xl={6} lg={8} md={12} sm={12} xs={12}>
            <Accordion transition={{ duration: "300ms", timingFunction: "cubic-bezier(0, 0, 0.2, 1)" }}>
              {content.map((element, index) => {
                return (
                  <AccordionItem key={`faq-accordionttem-${index}`}>
                    <AccordionHeader style={accordionHeaderStyle}>
                      <h2 style={accordionTitleStyle}>{element.q}</h2>
                    </AccordionHeader>
                    <AccordionBody>
                      <div style={accordionContentStyle}>
                        {element.a}
                      </div>
                    </AccordionBody>
                  </AccordionItem>
                )
              })}
            </Accordion>
          </Col>
        </Row>
      </section>
      <ArticleSection
        layout="article_left"
        title={t("common:sections.jobs.title")}
        content={
          <div>
            <p style={contentStyle}>{t("common:sections.jobs.content")}</p>
            <StyledButton title={t("common:sections.jobs.button")} onClick={() => {handleNavigation("https://bhmm.de/employees#job-offers", { openInNewTab: true })}} />
          </div>
        }
        imageUrl={bg_05}
        backgroundColor="#DDEBEA"
      />
    </Container>
  );
}

export default FAQs;
